
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Left = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <polygon points="15 19 8.4 12.5 15 6 16 7 10.6 12.5 16 18 15 19"></polygon>
        </g>
      </g>
    </IconBase>);
};

Left.defaultProps = {
  title: 'Left',
};

export default Left;
